import { addDays, endOfMonth, endOfWeek, eachDayOfInterval } from 'date-fns';

export const getMonthDays = (gridStart: Date): Date[] => {
  const targetMonthDay = addDays(gridStart, 6);
  const gridEnd = endOfWeek(endOfMonth(targetMonthDay), { weekStartsOn: 0 });
  return eachDayOfInterval({ start: gridStart, end: gridEnd });
};
